import { Button, IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import { Add, Close, Delete, Edit } from '@mui/icons-material';
import { Row } from 'antd';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import LoadingWrapper from 'components/LoadingWrapper';
import { get, map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleDeleteSchoologyCources, handleListSchoologyCourcesByDistId, handleUpdateSchoologyCources } from 'store/booksUnits/thunks';
import { useCurrentOrg } from 'store/organizations/selectors';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import SelectableBookByGroup from 'components/SelectBookByGroup';
const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:90vh;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;
const ModalSection =  styled.div`
    background-color: ${COLOR.white};
    display: inline-flex;
    flex-direction: column;
    width:90vw;
    height:100%;
    overflow:auto;
    padding: 16px;
`;

const CourseUpdate = ({ openEditModal, setOpenEditModal, selectedData , onUpdate }) => {
    const [courseName, setCourseName] = useState(get(selectedData, 'displayName', ''))
    const [courseBooksByGroup, setCourseBooksByGroup] = useState([])
    const [schoolId,setschoolId] =useState(null);
    const [loader, setLoader] = useState(null)
    const currentOrg = useCurrentOrg()
 
    useEffect(() => {
        if (selectedData) {
            setCourseName(get(selectedData, 'displayName', ''))
            setschoolId(get(selectedData, 'schoolId'))
            const books_group = get(selectedData, 'books_group', []) || []
           setCourseBooksByGroup(books_group)
        }
    }, [selectedData])
    const dispatch = useDispatch()
 
    const onCourseUpdate = async () => {
        const data = {
            id: get(selectedData, 'id', null),
            displayName: courseName,
            books_group: courseBooksByGroup,
            district_id:currentOrg.id,
            schoolId
        }
        setLoader(true)
        await dispatch(handleUpdateSchoologyCources(data))
        if(onUpdate){
            onUpdate()
        }
        setLoader(false)
        setOpenEditModal(false)
    }
    return (
        <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
            <ModalContent>
                <Row style={{ justifyContent: "flex-end", width: "100%" }}>
                    <IconButton
                        onClick={e => setOpenEditModal(false)}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <h2>{selectedData && selectedData.id ? "Update Course 2" : "Create Course"}</h2>
                <Row style={{ width: "100%" }}>
                    <TextField value={courseName} onChange={(e) => setCourseName(e.target.value)} label="Course Name *" variant="outlined" style={{ maxWidth: 400 }} />
                </Row>
                <ModalSection>
                    <SelectableBookByGroup
                        books_group={courseBooksByGroup}
                        onSelect={(item) => {
                            setCourseBooksByGroup(item)
                        }} />
                </ModalSection>
                <Row style={{ width: "100%", marginTop: 20 , justifyContent:"flex-end"}}>
                    <Button variant="contained" color="primary" onClick={onCourseUpdate}>{loader?<Loading size={14} white/>:null} {selectedData && selectedData.id ? "Update" : "Create"}</Button>
                </Row>
            </ModalContent>
        </Modal>
    )
}

export default function SchoologyBookMapByCourse({ district_id }) {
    const [courseList,setCourseList] = useState([])
    const [loading , setLoading] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedCourse,setSelectedCourse] = useState({});
    const [deleteToggle,setDeleteToggle] = useState(false);
    const [deleteLoader,setDeleteLoader] = useState(false);
    async function fetchdata() {
        setLoading(true)
        const data = await handleListSchoologyCourcesByDistId(district_id,"course")
        if (data && data.success) {
            setCourseList(get(data, 'data', []))
        }
        setLoading(false)
    }
    useEffect(() => {
        fetchdata()
    }, [])
    const onEdit = (data) => {
        setSelectedData(data)
        setOpenEditModal(true)
    }
    const onDeleteCourses = (data) => {
        setSelectedCourse(data)
        setDeleteToggle(true)
    }
    const onDelete= async()=>{
        setDeleteLoader(true)
        await handleDeleteSchoologyCources(selectedCourse.id)
        setDeleteLoader(false)
        setDeleteToggle(false)
        setSelectedCourse({})
        fetchdata()

    }
  return (
   <>
        <CourseUpdate openEditModal={openEditModal} selectedData={selectedData} setOpenEditModal={setOpenEditModal} onUpdate={fetchdata}   />
        <DeleteModal  deleteToggle={deleteToggle} setDeleteToggle={setDeleteToggle} message={`Are you sure you want to delete ${selectedCourse.displayName}?`} onDelete={onDelete} loading={deleteLoader} />
          <Wrapper>
          <Button variant="contained" color="primary" onClick={()=>onEdit({})}><Add/> Add Course</Button>
              <LoadingWrapper loading={loading}>
                  {courseList.length > 0 ? <Table style={{ width: "100%", textAlign: "center" }}>
                      <TableHead>
                          <TableRow>
                              <TableCell style={{ textAlign: "center" }}>Course name</TableCell>
                              <TableCell style={{ textAlign: "center" }}>Number of groups</TableCell>
                              <TableCell style={{ textAlign: "center" }}>Edit</TableCell>
                              <TableCell style={{ textAlign: "center" }}></TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {map(courseList, cuser => {
                              return (<>
                                  <TableRow key={cuser.id}>
                                      <TableCell style={{ textAlign: "center" }}>{get(cuser, "displayName", '')}</TableCell>
                                      <TableCell style={{ textAlign: "center" }}>{get(cuser, "books_group.length", '')}</TableCell>
                                      <TableCell style={{ textAlign: "center" }}><Button style={{ width: 85, height: 35 }} variant="text" onClick={()=>onEdit(cuser)} > <Edit style={{ color: COLOR.green }} /> </Button></TableCell>
                                      <TableCell style={{ textAlign: "center" }}><Button style={{ width: 85, height: 35 }} variant="text" onClick={() => onDeleteCourses(cuser)} > <Delete style={{ color: COLOR.red }} /> </Button></TableCell>
                                  </TableRow>
                              </>)
                          })}
                      </TableBody>
                  </Table> : null}
              </LoadingWrapper>
          </Wrapper>
   </>
  )
}
